import moment from 'moment'
import { deserialize } from 'cerialize'
import { ReceivingFileModel } from 'Models'
import { TIME_FORMAT, DATE_FORMAT_SHORT, DATE_FORMAT_FOR_BACKEND } from 'Constants/Global'
import {
	AstSigned,
	BankGuaranteeKinds,
	BankGuaranteeTypes,
	BgSubStatus,
	GuaranteeMediumTypeModel,
	GuaranteeTypeModel,
	PartnerBg,
	ProductType,
	PurchaseTypeModel,
} from 'Pages/ibro'
import { StatusBg } from './StatusBg'
import { UserBg } from './UserBg'

export class BankGuarantee {
	@deserialize public id!: number
	@deserialize public external_id!: number // ID от АСТ
	@deserialize public repaid!: boolean // Факт оплаты
	@deserialize public shortname!: string // Наименование компании
	@deserialize public principalinn!: string
	@deserialize public amount!: number // Сумма БГ
	@deserialize public commission!: number // стоимость гарантии для клиента
	@deserialize public purchasecode!: string // № извещения
	@deserialize public producttype!: ProductType // Тип продукта
	@deserialize public status!: StatusBg | null
	@deserialize public guaranteetype!: GuaranteeTypeModel // Тип БГ
	@deserialize public purchasetype!: PurchaseTypeModel // Тип закупки
	@deserialize public guaranteemediumtype!: GuaranteeMediumTypeModel // Тип получения БГ
	@deserialize public created_at!: string
	@deserialize public partner!: PartnerBg
	@deserialize public created_by_user?: UserBg
	@deserialize public startdate!: string
	@deserialize public enddate!: string
	@deserialize public contractstartdate!: string
	@deserialize public contractenddate!: string
	@deserialize public statementckr?: ReceivingFileModel // выписка из реестра
	@deserialize public managerguaranteeblank?: ReceivingFileModel // Бланк гарантии
	@deserialize public paymenttemplate?: ReceivingFileModel // платежное поручение
	@deserialize public purchaseidentificatcodeikz?: string // ИКЗ
	@deserialize public prototext?: string // наименование и реквизиты протокола
	@deserialize public segment?: string
	@deserialize public deliverylink?: string
	@deserialize public deliverycode?: string
	@deserialize public substatus?: BgSubStatus
	@deserialize public toggle_archived?: boolean
	@deserialize public archived?: boolean
	@deserialize public kind?: BankGuaranteeKinds
	@deserialize public signdate!: string | null // дата подписания документа
	@deserialize public original_external_id!: string | null // ID от оригинального АСТ
	@deserialize public url!: string // ссылка на закупку
	@deserialize public order_change_status_reason!: string
	@deserialize public order_sub_status_name!: string
	@deserialize public number!: string // Номер заявки в банке
	@deserialize public partner_reward_percentage!: number
	@deserialize public ptype!: BankGuaranteeTypes
	@deserialize public ast_signed!: AstSigned | null
	@deserialize public favorite!: boolean
	@deserialize public paymentdate!: string | null
	@deserialize public assigned!: boolean | null
	@deserialize public reasonofrejectionforclient!: string | null // Причина отказа партнеру

	public get time(): string | undefined {
		return moment(this?.created_at).format(TIME_FORMAT)
	}

	public get date(): string | undefined {
		return moment(this?.created_at).format(DATE_FORMAT_SHORT)
	}

	public get start(): string | undefined {
		return (
			this?.startdate && moment(this.startdate, DATE_FORMAT_FOR_BACKEND).format(DATE_FORMAT_SHORT)
		)
	}

	public get money(): string | undefined {
		return new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB' }).format(
			Number(this.amount)
		)
	}

	public get commission_money(): string | undefined {
		return this.commission
			? new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB' }).format(
					Number(this.commission)
			  )
			: undefined
	}
}
